import { render } from "./ProspectContacts.vue?vue&type=template&id=0123da8c"
import script from "./ProspectContacts.vue?vue&type=script&lang=js"
export * from "./ProspectContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__